import { Directive, ElementRef, Input, NgModule, OnChanges } from '@angular/core';

@Directive({
  selector: '[systemLink]',
  host: {
    class: 'font-medium  hover:underline cursor-pointer',
  },
})
export class LinkDirective implements OnChanges {
  @Input() linkType: 'primary' | 'secondary' = 'primary';

  private classes = {
    primary: 'text-system-400 dark:text-system-500',
    secondary: 'text-system-500 dark:text-system-400',
  };

  constructor(private el: ElementRef<HTMLElement>) {}

  ngOnChanges() {
    this.el.nativeElement.classList.add(...this.classes[this.linkType].split(' '));
  }
}

@NgModule({
  declarations: [LinkDirective],
  exports: [LinkDirective],
})
export class SystemLinkModule {}
